import styled from 'styled-components';
import Alert from '@material-ui/lab/Alert';

export const TitleContainer = styled.div`
  margin-bottom: ${p => p.marginBottom ?? '40px'};
`;

export const TermsContainer = styled.label`
  display: flex;
  justify-content: center;

  .MuiCheckbox-root {
    align-items: flex-start;
  }
`;

export const StyledAlert = styled(Alert)`
  position: relative;
  padding: 25px 16px;

  .MuiAlert-message {
    width: 100%;
  }

  .MuiAlert-action {
    position: absolute;
    top: 0;
    right: 0;
    margin-right: 0;

    .MuiIconButton-root {
      padding: 8px;
    }
  }
`;

export default TitleContainer;
